import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslate } from '../TranslationText';

/**
 * Radio button group connected to React Hook Form via Controller.
 *
 * @param {string} name - Form field name
 * @param {string} label - Group label
 * @param {Array} options - [{ text: 'Label', value: any }, ...]
 * @param {boolean} required - Show required indicator
 * @param {boolean} disabled - Disable all radios
 * @param {boolean} inline - Display radios inline (default: true)
 */
export default function FormRadio({
    name,
    label,
    options = [],
    required = false,
    disabled = false,
    inline = true,
}) {
    const { translate } = useTranslate();
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field, fieldState: { error } }) => (
                <div className="mb-3">
                    {label && (
                        <label className="form-label d-block capatalize_text">
                            {label}
                            {required && <span className="color-eahsred ms-1">*</span>}
                        </label>
                    )}
                    <div className={inline ? 'd-flex flex-wrap gap-3' : ''}>
                        {options.map((opt, i) => {
                            const id = `${name}-radio-${i}`;
                            const isChecked = field.value === opt.value;
                            return (
                                <div className="form-check" key={id}>
                                    <input
                                        id={id}
                                        type="radio"
                                        ref={field.ref}
                                        className="form-check-input"
                                        checked={isChecked}
                                        onChange={() => field.onChange(opt.value)}
                                        disabled={disabled}
                                        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                                    />
                                    <label
                                        htmlFor={id}
                                        className="form-check-label"
                                        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                                    >
                                        {opt.text}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                    {error && (
                        <div className="text-danger mt-1" style={{ fontSize: 13 }}>
                            {error.message || translate('web.requiredField', 'Required Field')}
                        </div>
                    )}
                </div>
            )}
        />
    );
}
